import { Button, Chip, Grid, IconButton, Paper, Tooltip, Typography, makeStyles } from "@material-ui/core";
import { green, orange, red } from "@material-ui/core/colors";
import { Android, AndroidRounded, Apple, GetApp, GetAppOutlined, GetAppRounded, LocalPlayOutlined, PhoneIphone } from "@material-ui/icons";
import { Skeleton } from "@material-ui/lab";
import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";

const Licenses = ({ isLoading, serialNumber, licences }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  //console.log(licences);
  return (
    <Grid container spacing={2} item>
      <Grid container item xs={12}>
        <Grid item xs={12} container alignItems="center">
          {isLoading ? (
            <Skeleton
              variant="circle"
              style={{
                marginRight: 8,
              }}
              width={30}
              height={30}
            />
          ) : (
            <LocalPlayOutlined
              color="secondary"
              style={{
                marginRight: 8,
                height: 30,
                width: 30,
              }}
            />
          )}

          <Typography color="secondary" style={{ fontWeight: 500, fontSize: 22, lineHeight: "30px" }}>
            {isLoading ? <Skeleton width={250} /> : "Licencias"}
          </Typography>
          {(licences.some((l) => !l?.active) || licences.length == 0) && (
            <Typography color="textSecondary" style={{ marginTop: 9, marginBottom: 16 }}>
              {t("device.licence.HowToEnable", { sn: serialNumber })}
            </Typography>
          )}
        </Grid>
      </Grid>
      {licences.map((e, i) => (
        <Grid item xs={12} sm={6} key={i}>
          <Paper variant="outlined" className={classes.paper} style={{ borderColor: e.active ? green[600] : red[600] }}>
            <Grid container>
              <Grid item xs={12} container direction="col" justifyContent="space-between">
                <Typography variant="h6" style={{ color: e.active ? green[600] : red[600] }}>
                  {isLoading ? <Skeleton width={250} /> : t(e.type)}
                </Typography>
                {!isLoading && e.type == "NFC Reader" && e.active && (
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={() => window.open("https://play.google.com/store/apps/details?id=com.bexencardio.conf_nfc2&hl=es&gl=US", "_blank")}
                    style={{ textTransform: "none", marginLeft: 9, justifySelf: "flex-end" }}
                    startIcon={<GetAppRounded />}
                  >
                    {t("Android")}
                  </Button>

                  /* <Chip
                      variant="outlined"
                      color="primary"
                      size="small"
                      label={t("sources.download.App")}
                      style={{ marginLeft: 9 }}
                      clickable
                      onClick={() => window.open("https://play.google.com/store/apps/details?id=com.bexencardio.conf_nfc2&hl=es&gl=US", "_blank")}
                    />*/
                )}
              </Grid>
              <Grid item xs={12}>
                {e.active ? (
                  <Typography variant="subtitle1" color="textSecondary">
                    {isLoading ? <Skeleton width={220} /> : `${t("active")} ${e.permanent ? " · " + t("permanent") : ""}`}
                  </Typography>
                ) : (
                  <Tooltip placement="top-start" title={<Typography>{t("license.updateToActive")}</Typography>}>
                    <Typography variant="subtitle1" color="textSecondary">
                      {isLoading ? <Skeleton width={220} /> : t("notActive")}
                    </Typography>
                  </Tooltip>
                )}

                <Typography variant="body2" style={{ marginTop: 12 }}>
                  {isLoading ? (
                    <>
                      <Skeleton />
                      <Skeleton />
                    </>
                  ) : e.type === "NFC Reader" ? (
                    t("licenses.nfc.description")
                  ) : (
                    t("licenses.RDNPLUS.description")
                  )}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default Licenses;

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 16,
    padding: theme.spacing(2),
    [theme.breakpoints.only("xs")]: {
      padding: theme.spacing(2),

      boxShadow: "0 0",
    },
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(3),
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
  },
}));
